"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEW_MARK_FIELDS = exports.MODIFY_MARKSHEET_COMPLETED_FRAGMENT = exports.MARK_FLAGGED_FIELD = exports.MODIFY_CURRENT_MARK_FRAGMENT = exports.MODIFY_TOPIC_SELECTION_FRAGMENT = exports.MODIFY_MARKSHEET_STATE_FRAGMENT = exports.MODIFY_MARKSHEET_MARK_STRIKED_FRAGMENT = exports.MODIFY_MARKSHEET_MARK_QUESTIONCHOICEID_FRAGMENT = exports.MODIFY_CURRENT_MARKSHEET_MARK_FRAGMENT = exports.MARKSHEET_FIELDS = exports.BUILDER_CONFIG_FIELDS = exports.MARKSHEET_MARK_FIELDS = void 0;
const client_1 = require("@apollo/client");
const question_1 = require("./question");
exports.MARKSHEET_MARK_FIELDS = (0, client_1.gql) `
  ${question_1.QUESTION_FIELDS}
  fragment MarksheetMarkFields on MarksheetMark {
    id
    flagged
    index
    questionChoiceId
    marksheetId
    timeTaken
    isAnswered
    striked
    mark
    questionId
    question {
      ...QuestionFields
    }
  }
`;
exports.BUILDER_CONFIG_FIELDS = (0, client_1.gql) `
  fragment BuilderConfigFields on BuilderConfigData {
    difficulty
    isTest
    numberOfQuestions
    secondsPerQuestion
    unseen
    seenCorrect
    seenIncorrect
  }
`;
exports.MARKSHEET_FIELDS = (0, client_1.gql) `
  ${exports.MARKSHEET_MARK_FIELDS}
  ${exports.BUILDER_CONFIG_FIELDS}
  fragment MarksheetFields on Marksheet {
    id
    topicConceptData
    currentMarkId
    completed
    passingMark
    duration
    timeTaken
    topicIds
    topicNames
    mockTestId
    totalQuestions
    solo
    agoraId
    sessionId
    state
    createdAt
    startedAt
    endedAt
    typeId
    isTestMarksheet
    source
    correct
    incorrect
    entitlement {
      id
      name
    }
    preBuildData {
      buildRef
      seenCorrect
      seenIncorrect
      unseen
    }
    user {
      id
      displayName
    }
    users {
      id
      displayName
    }
    activeUsers {
      id
      displayName
    }
    builderConfig {
      ...BuilderConfigFields
    }
    marks {
      ...MarksheetMarkFields
    }
  }
`;
/**
 * All below fragments are used in cache updator
 */
exports.MODIFY_CURRENT_MARKSHEET_MARK_FRAGMENT = (0, client_1.gql) `
  fragment CurrentMarksheetMark on MarksheetMark {
    index
    timeTaken
  }
`;
exports.MODIFY_MARKSHEET_MARK_QUESTIONCHOICEID_FRAGMENT = (0, client_1.gql) `
  fragment MarksheetMarkTimeTaken on MarksheetMark {
    questionChoiceId
  }
`;
exports.MODIFY_MARKSHEET_MARK_STRIKED_FRAGMENT = (0, client_1.gql) `
  fragment MarksheetMarkSriked on MarksheetMark {
    striked
  }
`;
exports.MODIFY_MARKSHEET_STATE_FRAGMENT = (0, client_1.gql) `
  fragment MarksheetState on Marksheet {
    state
  }
`;
exports.MODIFY_TOPIC_SELECTION_FRAGMENT = (0, client_1.gql) `
  fragment MarksheetTopicSelection on Marksheet {
    topicConceptData
  }
`;
exports.MODIFY_CURRENT_MARK_FRAGMENT = (0, client_1.gql) `
  fragment MarksheetCurrentMark on Marksheet {
    currentMarkId
  }
`;
exports.MARK_FLAGGED_FIELD = (0, client_1.gql) `
  fragment MarksheetMarkFlagged on MarksheetMark {
    flagged
  }
`;
exports.MODIFY_MARKSHEET_COMPLETED_FRAGMENT = (0, client_1.gql) `
  fragment MarksheetCompleted on Marksheet {
    timeTaken
    completed
    correct
    incorrect
    duration
    endedAt
  }
`;
exports.NEW_MARK_FIELDS = (0, client_1.gql) `
  fragment NewTodoMark on MarksheetMark {
    timeTaken
    questionChoiceId
    mark
    isAnswered
  }
`;
